<template>
  <v-app class="backcolor">
    <v-container fluid>
      <v-btn
        v-if="files.length !== 0"
        fixed
        right
        fab
        absolute
        x-large
        color="darkcolor"
        style="bottom: 40px; right: 40px"
        class="elevation-24"
        @click="fileDialog = true"
      >
        <v-icon color="white">mdi-folder-multiple</v-icon>
      </v-btn>

      <!--LISTA DE AULAS-->
      <v-row class="px-5">
        <v-col
          v-for="lessons in classes"
          :key="lessons.id"
          cols="12"
          sm="6"
          md="4"
          lg="3"
        >
          <v-card class="mx-auto rounded-lg" @click="classDetails(lessons)">
            <v-img
              max-height="180"
              lazy-src="http://www.makereducacional.com.br/images/Curso Padrão PT.png"
              :src="lessons.tumbnail == null ? lessons.thumbCurso : lessons.tumbnail"
              :aspect-ratio="9 / 16"
            />

            <v-card-actions class="font-weight-bold px-2 px-md-4 darkblue white--text">
              {{ lessons.title }}

              <v-spacer></v-spacer>

              <!-- Status da Aula -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    :color="lessons.progressIcon.color"
                    v-bind="attrs"
                    v-on="on"
                    size="1.75rem"
                  >
                    {{ lessons.progressIcon.icon }}
                  </v-icon>
                </template>
                <span> {{ lessons.progressIcon.text }}</span>
              </v-tooltip>

              <!-- Ícone de Lição de Casa -->
              <v-tooltip top v-if="lessons.homework">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    :color="lessons.homeworkdone ? 'green' : 'yellow'"
                    v-bind="attrs"
                    v-on="on"
                    size="1.75rem"
                  >
                    {{ lessons.homeworkdone ? 'mdi-check-circle' : 'mdi-clipboard-text' }}
                  </v-icon>
                </template>
                <span>
                  {{ lessons.homeworkdone ? $t('homework.entregue') : $t('homework.pendente') }}
                </span>
              </v-tooltip>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col
          v-if="hasClass === 0"
          cols="12"
          sm="11"
          class="mx-auto"
          align-self="center"
        >
          <v-img
            src="../../assets/History.svg"
            :max-width="$vuetify.breakpoint.smAndUp ? '35%' : '100%'"
            class="mx-auto my-4"
          ></v-img>
          <div class="text-h5 text-sm-h4 text-center font-weight-medium">
            {{ $t('alerta.alerta_auladisponivel') }}
          </div>
          <div
            class="text-sm-h6 px-sm-16 text-center font-weight-normal text--secondary"
          >
            {{ $t('alerta.alerta_recarregue') }}
          </div>
        </v-col>
      </v-row>

      <!--DETALHES DA AULA-->
      <v-dialog
        v-model="classDialog"
        persistent
        transition="dialog-top-transition"
        width="70%"
        :fullscreen="$vuetify.breakpoint.xsOnly"
      >
        <v-card class="rounded-lg">
          <v-card-title
            class="font-weight-medium text-subtitle-1 darkblue white--text"
          >
            {{ $t('student.student_detalheresaula') }}
            <v-spacer />
            <v-btn
              dark
              icon
              @click="
                classDialog = false;
                alert = false;
              "
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text
            class="px-4 px-lg-12 py-4 py-sm-8 py-md-10 d-flex"
            :class="$vuetify.breakpoint.smAndUp ? 'flex-row' : 'flex-column'"
          >
            <div class="text-center mb-2">
              <v-avatar
                :size="$vuetify.breakpoint.mdAndUp ? 260 : 200"
                tile
                class="rounded-xl mx-auto"
              >
                <v-img :src="thumb" />
              </v-avatar>
            </div>

            <div
              :style="
                $vuetify.breakpoint.mdAndUp
                  ? 'font-size: 1.2rem'
                  : 'font-size: 1rem'
              "
              class="mt-4"
              :class="$vuetify.breakpoint.smAndUp ? 'ml-6' : ''"
            >
              <div
                :style="
                  $vuetify.breakpoint.mdAndUp
                    ? 'font-size: 1.6rem'
                    : 'font-size: 1.2rem'
                "
                class="font-weight-black"
              >
                {{ title }}
              </div>

              <div class="mt-4"><strong v-if="project" >{{ $t('homework.homework_detalhes.detalhes1') }}</strong> {{ project }}</div>
              <div><strong>{{ $t('homework.homework_detalhes.detalhes2') }}</strong> {{ kit }}</div>
              <div><strong>{{ $t('homework.homework_detalhes.detalhes3') }}</strong> {{ description }}</div>

              <div
                class="mt-4 mt-md-10 mt-lg-16"
                :class="$vuetify.breakpoint.smAndUp ? '' : 'text-center'"
              >
                <v-btn
                  dark
                  color="darkpink"
                  rounded
                  class="px-8"
                  @click="toClass(idClass)"
                >
                  <v-icon left> mdi-play-outline </v-icon>
                  {{ $t('botoes.botao_inicia') }}
                </v-btn>

                <v-btn v-if="hasHomework"
                  dark
                  color="darkpink"
                  rounded
                  class="px-8"
                  @click="getHomework"
                  style="margin-left: 2em;"
                >
                  <v-icon left> mdi-file-document-outline </v-icon>
                  {{ $t('botoes.botao_homework') }}
                </v-btn>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      
      <v-dialog
        v-model="fileDialog"
        :max-width="$vuetify.breakpoint.mdAndUp ? '45%' : '90%'"
      >
        <v-card class="rounded-lg">
          <v-card-title
            class="
              darkblue
              white--text
              font-weight-bold
              d-flex
              justify-space-between
            "
            style="font-size: 1.6rem"
          >
            <span>{{ $t('homework.homework_tab.tab2') }}</span>
            <v-btn icon dark @click="fileDialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-card-title>
          <v-card-text class="pt-2 pb-6 px-6">
            <v-row class="mt-1">
              <v-col
                cols="12"
                sm="6"
                v-for="(file, index) in files"
                :key="file.id"
              >
                <v-card
                  :href="file.uri"
                  target="_blank"
                  class="pa-0 flat white--text"
                  height="100"
                >
                  <v-alert
                    height="100%"
                    class="
                      d-flex
                      align-center
                      justify-center
                      font-weight-medium
                      text-center
                    "
                    style="font-size: 1.3rem"
                    :color="colorLookLight(index)"
                    text
                    outlined
                  >
                    <span class="font-weight-bold black--text">
                      {{ file.description }}
                    </span>
                  </v-alert>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- DIÁLOGO PARA ENVIO DE LIÇÃO DE CASA -->
      <v-dialog v-model="homeworkDialog" persistent width="70%">
        <v-card class="rounded-lg">
          <v-card-title class="font-weight-medium text-subtitle-1 darkblue white--text">
            {{ $t('homework.enviar_licao') }}
            <v-spacer />
            <v-btn dark icon @click="homeworkDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="px-4 py-4">
            <div v-if="homeworkUrl != null">
              <p>{{ $t('hometeacher.arquivo_descricao_enviado') }}</p>
              <a :href="homeworkUrl" target="_blank" class="font-weight-medium">
                {{ $t('hometeacher.ver_arquivo') }}
              </a>
            </div>
          </v-card-text>

          <!-- Upload de Arquivo -->
          <v-card-text class="px-4 py-4">
            <v-file-input
              v-model="file"
              accept=".pdf,.doc,.docx,.txt,.jpg,.png,.jpeg"
              :label="$t('homework.selecione_arquivo')"
              prepend-icon="mdi-upload"
              outlined
              dense
            ></v-file-input>

            <v-btn
              color="darkpink"
              dark
              rounded
              class="mt-4"
              @click="uploadHomework"
              :disabled="!file"
            >
              <v-icon left>mdi-upload</v-icon>
              {{ $t('botoes.botao_enviar') }}
            </v-btn>
          </v-card-text>

          <!-- Lista de Arquivos Enviados -->
          <v-card-title class="font-weight-medium mt-6 text-subtitle-1">
            {{ $t('homework.arquivos_enviados') }}
          </v-card-title>

          <v-card-text>
            <v-simple-table>
              <thead>
                <tr>
                  <th>{{ $t('homework.coluna_arquivo') }}</th>
                  <th>{{ $t('homework.coluna_enviado') }}</th>
                  <th>{{ $t('homework.coluna_corrigido') }}</th>
                  <th>{{ $t('homework.coluna_nota') }}</th>
                  <th>{{ $t('homework.coluna_data_corrigido') }}</th>
                  <th>{{ $t('homework.coluna_acoes') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(task, index) in submittedTasks" :key="index">
                  <td><a :href="task.url" target="_blank">{{ task.filename }}</a></td>
                  <td>{{ formatarData(task.createdAt) }}</td>
                  <td>{{ task.fixed ? 'Sim' : 'Não' }}</td>
                  <td>{{ task.note || '-' }}</td>
                  <td>{{ task.fixed ? formatarData(task.updatedAt) : '-' }}</td>
                  <td>
                    <v-btn
                      icon
                      color="red"
                      @click="deleteHomework(task.id)"
                      :disabled="task.fixed"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-dialog>

    </v-container>
  </v-app>
</template>

<script>
// import ProfilePictures from "./ProfilePictures";
const axios = require("axios");
const url = process.env.VUE_APP_API_URL;
const token = "Baerer " + localStorage.getItem("accessToken");

export default {
  name: "StudentClasses",
  data: () => ({
    classes: [],
    rating: [],
    classDialog: false,
    alert: false,
    lastLesson: 1,
    classColors: [
      { light: "pink ", dark: "darkpink" },
      { light: "cyan", dark: "darkcyan" },
      { light: "yellow", dark: "darkyellow" },
    ],
    title: "",
    description: "",
    thumb: "",
    project: "",
    kit: "",
    idClass: null,
    idAppliedClass: null, 
    hasHomework: false, 
    hasClass: null,
    progressValue: null,
    idStudent: [],
    profileData: [],
    files: {},
    fileDialog: false,

    homeworkDialog: false,
    file: null,
    submittedTasks: [],
    homeworkUrl: null,
  }),
  async created() {
    await this.getProfile()
      setTimeout(() => {
        let courseId = this.profileData.student.team.courseId;
        this.getClasses(courseId);
      }, 500);
  },
  methods: {
    async getProfile() {
      let profile = await axios.get(`${url}/profilesForStudent`, {
        headers: {
          authorization: token,
        },
      });
      this.profileData = profile.data;
    },    
    async getFilesCourse(id) {
      try {
        let res = await axios.get(`${url}/filesCourses/byCourse/${id}`, {
          headers: {
            authorization: token,
          },
        });
        this.files = res.data;
      } catch (error) {
        console.error(error);
      }
    },
    async getClasses(courseId) {
      this.getFilesCourse(courseId);
      axios
        .get(`${url}/classesForStudent/${courseId}`, {
          headers: {
            authorization: token,
          },
        })
        .then((res) => {
          this.hasClass = res.data.length;
          this.classes = res.data;

          if (this.hasClass) {
            this.idStudent = this.classes[0].idstudent;
            this.checkStep();
            this.$forceUpdate();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    colorLookLight(index) {
      let position = (index + 1) % 3;
      let color = this.classColors[position].light;
      return color;
    },
    colorLookDark(index) {
      let position = (index + 1) % 3;
      let color = this.classColors[position].dark;
      return color;
    },
    classDetails(classes) {
      this.classDialog = true;
      setTimeout(() => {
        this.alert = true;
      }, 150);

      let classLocal = this.classes.indexOf(classes);
      if (this.classLocal == -1) {
        console.error("ERRO");
      }
      this.title = this.classes[classLocal].title;
      this.description = this.classes[classLocal].description;
      this.project = this.classes[classLocal].project;
      this.kit = this.classes[classLocal].kit;
      this.thumb = this.classes[classLocal].tumbnail;
      if (this.thumb == null) this.thumb = this.classes[classLocal].thumbCurso;
      this.idClass = this.classes[classLocal].id;
      this.idAppliedClass = this.classes[classLocal].appliedClassId;
      this.hasHomework = this.classes[classLocal].homework;
      this.homeworkUrl = this.classes[classLocal].homeworkurl;
    },
    toClass(exercisesByClass) {
      // console.log(exercisesByClass)
      // console.log(this.classes)
      this.$parent.$parent.$parent.exercisesByClassId = exercisesByClass;
      this.checkProgress(exercisesByClass);
      this.$emit("message", this.$t('admin.admin_menu.menu3'));
      this.classDialog = false;
      this.alert = false;
      this.$parent.$parent.$parent.page = this.$t('admin.admin_menu.menu18');
    },
    async checkProgress(id) {
      let progress = await axios.get(
        `${url}/progressLessons?classes=${id}&student=${this.idStudent}`,
        {
          headers: {
            authorization: token,
          },
        }
      );

      if (progress.data.length == 0) {
        let body = {
          classId: id,
          review: false,
          exercise: false,
          activity: false,
          studentId: this.idStudent,
        };
        await axios.post(`${url}/progressLessons`, body, {
          headers: {
            authorization: token,
          },
        });
      }
    },
    checkStep() {
      const verifyStage = {
        "0-0-1": {
          icon: "mdi-check-decagram",
          color: "light-green accent-4",
          text: this.$t('student.student_verifystage.verifystage1'),
        },
        "0-0-0": {
          icon: "mdi-clock-outline",
          color: "blue-grey lighten-4",
          text: this.$t('student.student_verifystage.verifystage2'),

        },
        "1-1-1": {
          icon: "mdi-check-decagram",
          color: "light-green accent-4",
          text: this.$t('student.student_verifystage.verifystage1'),
        },
        "1-0-1": {
          icon: "mdi-progress-check",
          color: "blue-grey lighten-4",
          text: this.$t('student.student_verifystage.verifystage3'),
        },
        "1-1-0": {
          icon: "mdi-progress-check",
          color: "yellow",
          text: this.$t('student.student_verifystage.verifystage3'),
        },
        "1-0-0": {
          icon: "mdi-clock-outline",
          color: "blue-grey lighten-4",
          text: this.$t('student.student_verifystage.verifystage2'),
        },
      };

      for (let i = 0; i < this.classes.length; i++) {
        const element = this.classes[i];
        const key = `${element.hasExercise}-${element.exercise}-${element.applied}`;
        const result = verifyStage[key] || "err";

        this.classes[i].progressIcon = result;
      }
    },

    getHomework() {
      axios
        .get(`${url}/homework?id=${this.idAppliedClass}`, {
          headers: {
            authorization: token,
          },
        })
        .then((res) => {
          this.submittedTasks = res.data;
          this.homeworkDialog = true;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async uploadHomework() {
      let formData = new FormData();
      formData.append("file", this.file, this.file.name);
      const resUpload = await axios.post(`${url}/homework/files`, formData);
      let link = resUpload.data.url;

      const form = { 
        appliedClassId: this.idAppliedClass, 
        studentId: this.profileData.studentId, 
        filename: this.file.name, 
        url: link, 
        fixed: false
      };
      await axios.post(`${url}/homework`, form, {
        headers: {
          authorization: token,
        },
      });

      this.getHomework();
    },
    formatarData(data) {
      const d = new Date(data);
      const dia = String(d.getDate()).padStart(2, '0');
      const mes = String(d.getMonth() + 1).padStart(2, '0');
      const ano = d.getFullYear();
      return `${dia}/${mes}/${ano}`;
    },
    async deleteHomework(id) {
      if (confirm("Deseja excluir esse envio?")) {
        await axios.delete(`${url}/homework/${id}`, {
          headers: {
            authorization: token,
          },
        });
        this.getHomework();
      }
    }
  },
};
</script>

<style>
.oneClass {
  position: relative;
}

.pointer {
  cursor: pointer;
}
</style>

<!-- Estilo Customizado -->
<style scoped>
.v-card-title {
  justify-content: center;
  text-align: center;
}

.v-file-input {
  max-width: 400px;
  margin: 0 auto;
}

.v-simple-table {
  width: 100%;
  text-align: center;
}

</style>